import { render } from "./fomo3d.vue?vue&type=template&id=643c3704"
import script from "./fomo3d.vue?vue&type=script&lang=js"
export * from "./fomo3d.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__